import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';

export default css`
  .key-features {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 672px;
    padding-bottom: 16px;
  }

  @media screen and (min-width: ${screen.smMin}) {
    .key-features {
      padding-top: 8px;
      padding-bottom: 0px;
    }
  }

  .title {
    align-self: flex-start;
    margin: 20px 0px;
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${colors.BLACK};
  }

  @media screen and (min-width: ${screen.smMin}) {
    .title {
      margin: 20px 0px;
      font-size: 20px;
    }
  }

  .feature-groups-container {
    display: flex;
    width: 100%;
    max-width: 672px;
    margin-bottom: 16px;
  }

  @media screen and (min-width: ${screen.smMin}) {
    .feature-groups-container {
      justify-content: space-between;
      padding-top: 24px;
      margin-bottom: 24px;
    }
  }

  .right-features {
    width: 47%;
  }

  .left-features {
    width: 47%;
    text-align: right;
  }

  @media screen and (min-width: ${screen.smMin}) {
    .left-features {
      text-align: initial;
    }
  }

  .more-features {
    width: 100%;
    margin-bottom: 16px;
  }

  @media screen and (min-width: ${screen.smMin}) {
    .more-features {
      margin-bottom: 24px;
    }
  }
`;
